import React from 'react';
import './NotFound.css';
import { NotFoundLayout } from '../AZmed/Layouts/NotFoundLayout';

export default function NotFound() {
  return <NotFoundLayout />;
}
